import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'firstSentence'
})
export class FirstSentencePipe implements PipeTransform {
    transform(value: string, maxLength: number = 250): string {
        if (!value) return '';

        const plain = value.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        const sentences = plain.split(/[.!?]+/).map(s => s.trim()).filter(s => s.length > 0);

        if (sentences.length === 0) return this.truncate(plain, maxLength);

        const different = this.findDifferentSentence(sentences);
        if (different && !this.startsWithSamePart(sentences[0], different)) {
            return this.truncate(different, maxLength);
        }

        const combined = this.combineSentences(sentences);
        if (combined) return this.truncate(combined, maxLength);

        const contextual = this.generateContextualSummary(sentences);
        if (contextual) return this.truncate(contextual, maxLength);

        return this.truncate(sentences[0], maxLength);
    }

    private findDifferentSentence(sentences: string[]): string {
        for (let i = 1; i < sentences.length; i++) {
            const s = sentences[i];
            if (s.length > 30 && !this.hasWeakStart(s)) return s;
        }
        return '';
    }

    private combineSentences(sentences: string[]): string {
        if (sentences.length < 2) return '';
        const first = sentences[0];
        const second = sentences[1];
        if (second.length > 30) return `${first}. ${second}.`;
        return '';
    }

    private generateContextualSummary(sentences: string[]): string {
        const fullText = sentences.join('. ');
        const actionVerbs = [
            'aprender', 'dominar', 'entender', 'descubrir', 'aplicar',
            'resolver', 'comprender', 'desarrollar', 'mejorar', 'crear',
            'manejar', 'controlar', 'optimizar', 'potenciar'
        ];
        for (const verb of actionVerbs) {
            if (fullText.toLowerCase().includes(verb)) {
                for (const sentence of sentences) {
                    if (sentence.toLowerCase().includes(verb)) return sentence;
                }
            }
        }
        return '';
    }

    private hasWeakStart(text: string): boolean {
        return [
            /^O (tal vez|sea|bien)/i, /^Pero /i, /^Sin embargo/i,
            /^Además/i, /^Incluso/i, /^Por lo tanto/i,
            /^En este/i, /^En esa/i, /^Algunos/i, /^Muchos/i
        ].some(p => p.test(text));
    }

    private startsWithSamePart(a: string, b: string): boolean {
        return a.substring(0, 40) === b.substring(0, 40);
    }

    private truncate(text: string, maxLength: number): string {
        if (text.length <= maxLength) return text;
        const words = text.split(' ');
        let result = '';
        for (const word of words) {
            if ((result + ' ' + word).trim().length <= maxLength) {
                result = (result + ' ' + word).trim();
            } else break;
        }
        return result ? result + '...' : text.substring(0, maxLength) + '...';
    }
}
